import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import authService from '../services/authService';
import './Login.css';
import Swal from 'sweetalert2';
import logsUserService from '../services/logsUserServices';
import Header from './Header';

const Login = () => {
  const [cedula, setCedula] = useState('');
  const { login } = useAuth();
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await authService.login(cedula);
      const token = response.access;
      const name = response.name;
      const id_user = response.id_user

      if (token) {
        login(token, name, id_user);

        // registramos la accion
        // logsUserService(
        //   response.id_user,
        //   'Login',
        //   response.access,
        // );

        navigate('/crear-evento');
      } else {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'error al iniciar sesión. token no valido',
          customClass: {
            title: "text-center"
          },
          showConfirmButton: false, // Mostrar el botón de confirmación
          timer: 2500,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: err.message,
        customClass: {
          title: "text-center"
        },
        showConfirmButton: false, // Mostrar el botón de confirmación
        timer: 2500,
        timerProgressBar: true,
      });

      setError(err.message);
    }
  };


  return (

    <div className="external-container d-flex justify-content-center align-items-center vh-100">
      <header className="header">
        <nav className="navbar navbar-expand-md fixed-top navbar-light bg-transparent">
          <div className="container-fluid d-flex justify-content-end align-items-center">
            {/* <a className="navbar-brand order-3">
              <img src="./aviancaLogo.png" className="mx-3 img-fluid" alt="logo" />
            </a> */}
          </div>
        </nav>
      </header>

      <div className="container d-flex justify-content-center align-items-center flex-column mt-5">
        <div className="col-12 m-0 p-0 m-t-0 mb-3">
          <div className="col-12 d-flex justify-content-center align-items-center mt-5">
            <div className="d-flex justify-content-center align-items-center flex-lg-row flex-column mt-5">
              <div className="col-12 col-lg-5 mx-3 d-flex justify-content-center align-items-center flex-column mt-5">
                <h1 className="title-login-sesion Bebas-Neue">login administrativo</h1>
                <form className="login-form w-100 d-flex justify-content-center align-items-center flex-column" onSubmit={handleSubmit}>

                  <input
                    type="number"
                    className="form-container-input text-danger text-center"
                    name="dni"
                    placeholder='Ingresa tu cédula'
                    value={cedula}
                    onChange={(e) => setCedula(e.target.value)}
                    required
                  />
                  <button type="submit" className="form-container-button w-55 lowercase">Continuar</button>
                </form>
              </div>
              <div className="col-12 col-lg-6 mx-3 d-flex justify-content-center align-items-center">
                <img src="./aviancaLogo.png" className="container-logo-events" alt="avianca" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* footer mobile */}
      <footer className="d-block d-md-none d-lg-none d-xl-none col-12 mt-auto">
        <div className="d-flex justify-content-between align-items-center text-white mb-2">
          <div className='mx-4 mb-3'>
            <img src="./Logo-SuperTransporte.png" style={{ width: '150%' }} alt="logo" />
          </div>
          <div className='text-end mx-4 mb-3'>
            <img src="./Logo-Footer-2.png" style={{ width: '80%' }} alt="logo" />
          </div>
        </div>
      </footer>

      <footer className="d-none d-md-block d-lg-block d-xl-block col-12 mt-auto col-12 mt-auto bg-transparent">
        <div className="d-flex justify-content-between align-items-center text-white mb-2">
          <div className='mx-4 mb-3'>
            <img src="./Logo-SuperTransporte.png" style={{ width: '75%' }} alt="logo" />
          </div>
          <div className='text-end mx-4 mb-3'>
            <img src="./Logo-Footer-2.png" style={{ width: '35%' }} alt="logo" />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Login;
